<template>
  <div id="page" class="container-fluid">
  <div class="row header mx-4 my-4">
    <div class="col my-3">
      <h1>Facility Fee Schedules
        <b-button class="ml-3" variant="outline-orange" @click="addAscFeeSchedule()">
          <font-awesome-icon class="orange" icon="plus"/>
          New
        </b-button></h1>
    </div>
  </div>

  <div class="container-fluid">
    <div class="row data-table-header">
      <div class="col-2">Name</div>
      <div class="col-2">Effective Date</div>
      <div class="col-2">Discount Strategy</div>
      <div class="col-2">Self Pay</div>
      <div class="col-2"></div>
      <div class="col-2"></div>
    </div>
    <div v-for="ascFeeSchedule in ascFeeSchedules" class="row data-table-row" :key="ascFeeSchedule.organizationAscFeeScheduleId">
      <div class="col-12">
        <div class="row align-items-center">
          <div class="col-2 column align-middle">{{ ascFeeSchedule.name }}</div>
          <div class="col-2 column align-middle">{{ formatFeeScheduleDate(ascFeeSchedule.effectiveDate) }}</div>
          <div class="col-2 column align-middle">{{ discountStrategy (ascFeeSchedule.discountStrategy) }}</div>
          <div class="col-2 column align-middle">{{ selfPay(ascFeeSchedule.isSelfPay)}} </div>
          <div class="col-4 text-right">
            <button title="Codes" @click.prevent="goToAscFeeScheduleCodes(ascFeeSchedule)" type="button" class="btn btn-outline-orange m-1 wide-button">
              <font-awesome-icon class="orange mr-2" :icon="['far', 'square-arrow-up-right']"/>Codes
            </button>
            <button title="Edit" @click.prevent="editAscFeeSchedule(ascFeeSchedule)" type="button" class="btn btn-outline-orange m-1 wide-button">
            <font-awesome-icon class="orange mr-2" :icon="['far', 'edit']"/>Edit
          </button>
          <button title="Delete" @click.prevent="confirmDelete(ascFeeSchedule.organizationAscFeeScheduleId)" type="button" class="btn btn-outline-orange m-1 wide-button">
            <font-awesome-icon class="orange mr-2" :icon="['far', 'trash-alt']"/>Delete
          </button>
            </div>
        </div>
        </div>
      </div>
    </div>
    <asc-fee-schedules-modal :edit-asc-fee-schedule="editingAscFeeSchedule" @updated="ascFeeScheduleUpdated" :visible="showingAscFeeScheduleModal"
                @update:visible="visible => showingAscFeeScheduleModal = visible"></asc-fee-schedules-modal>

    <confirm-modal :title="confirmTitle"
                   @confirmed="deleteConfirmed"
                   confirmButton="Delete"
                   :copy="confirmCopy"
                   :visible="showConfirmation"
                   @update:visible="visible => showConfirmation = visible"></confirm-modal>
    <loading-modal :visible="showingLoadingModal" :return-focus="$refs.searchInput"
                   @update:visible="visible => showingLoadingModal = visible"></loading-modal>
  </div>
</template>

<script>
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import moment from 'moment-timezone'
  import api from '@/services/api'
  import LoadingModal from '@/components/LoadingModal'
  import AscFeeSchedulesModal from '@/components/AscFeeSchedulesModal'
  import ConfirmModal from '@/components/ConfirmModal'

  export default {
    name: 'AscFeeSchedules',

    components: { LoadingModal, AscFeeSchedulesModal, ConfirmModal },

    mixins: [ErrorsMixin],

    data () {
      return {
        isLoading: true,
        errors: [],
        showingAscFeeScheduleModal: false,
        editingAscFeeSchedule: {},
        totalPages: 0,
        currentPage: 1,
        pageSize: 20,
        searchTerm: '',
        confirmingDelete: true,
        showConfirmation: false,
        feeScheduleId: 0,
        showingLoadingModal: false,
        ascFeeSchedules: []
      }
    },
    methods: {
      loadData (silent = false) {
        if (!silent) {
          this.showingLoadingModal = true
        }
        api.get('Dashboard/AscFeeSchedules').then(response => {
          this.ascFeeSchedules = response.data
          this.showingLoadingModal = false
        })
      },
      addAscFeeSchedule () {
        this.editingAscFeeSchedule = {}
        this.showingAscFeeScheduleModal = true
      },

      goToAscFeeScheduleCodes (feeSchedule) {
        this.$router.push({
          name: 'asc-fee-schedules-codes', params: { id: feeSchedule.organizationAscFeeScheduleId }
        })
      },

      editAscFeeSchedule (ascFeeSchedule) {
        this.editingAscFeeSchedule = ascFeeSchedule
        this.showingAscFeeScheduleModal = true
      },
      ascFeeScheduleUpdated () {
        this.showingAscFeeScheduleModal = false
        this.loadData()
      },
      confirmDelete (ascFeeSchedule) {
        this.showConfirmation = true
        this.feeScheduleId = ascFeeSchedule
      },

      deleteFeeSchedule () {
        if (this.confirmingDelete) {
          api.delete('Dashboard/AscFeeSchedules/' + this.feeScheduleId).then(() => {
            this.loadData()
          }).catch(error => {
            this.isSaving = false
            if (!this.$store.canHandleNetworkError(error)) {
              this.setFromApiErrorResponse(error)
            }
          })
          this.feeScheduleId = 0
        }
      },

      deleteConfirmed (confirmation) {
        this.showConfirmation = false
        if (confirmation === true) {
          this.deleteFeeSchedule()
        }
      },
      formatFeeScheduleDate (date) {
        return moment(date).utc().format('MM/DD/YYYY')
      },
      discountStrategy (strategy) {
        if (strategy === null) {
          return '100%'
        }
        if (strategy === 'FirstFull50Remaining') {
          return '100% 50%'
        }
        if (strategy === 'Discount25EachToZero') {
          return '100% 50% 25% 0%'
        }
        if (strategy === 'Discount25Each') {
          return '100% 50% 25%'
        }
        if (strategy === 'All60') {
          return '60%'
        }
        if (strategy === 'Discount25EachWithDouble25') {
          return '100% 50% 25% 25% 0%'
        }
        if (strategy === 'FirstFullAt50ThenZero') {
          return '100% 50% 50% 0%'
        }
      },

      selfPay (pay) {
        if (pay === true) {
          return 'Yes'
        }
        if (pay === false) {
          return 'No'
        }
      }
    },

    computed: {
      confirmTitle () {
        return 'Delete Fee Schedule'
      },

      confirmButton () {
        if (this.confirmingDelete) {
          return 'Void'
        } else {
          return 'Check In'
        }

      },
      confirmCopy () {
        if (this.confirmingDelete) {
          return 'Are you sure you want to delete this fee schedule?'
        }
        return ''
      }
    },

    created () {
      this.loadData()
    }
  }
</script>
